import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService, ProjectService } from '@catcore/services';
import { ProjectChecklistService } from '@catmodules/models/project-checklist/services/project-checklist.service';
import { Subscription } from 'rxjs/Subscription';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'cat-project-checklist',
  templateUrl: './project-checklist.component.html',
  styleUrls: ['./project-checklist.component.scss'],
})

export class ProjectChecklistComponent implements OnInit, OnDestroy {

  private projectSubscription: Subscription;
  project = null;

  checklist: any;
  items: any;

  @ViewChild('panel') panel;

  constructor(private projectService: ProjectService,
              private projectChecklistService: ProjectChecklistService,
              private notificationService: NotificationsService,
              private sanitizer: DomSanitizer) { }
  ngOnInit() {
    // first get the current project
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        console.log('Found project:', project);
        if (isActiveProject) {
          this.project = project;
          this.projectChecklistService.setActive();
          this.updateChecklist();
        }
      });
  }
  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
    this.projectChecklistService.setInActive();
  }

  exportToHtml() {
    const html = '<html><head>' +
      '<style>' +
      'body, th, td, li { ' +
      '    font-size: 10pt;' +
      '    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;' +
      '}' +
      'table, th, td {' +
      '    border: 1px solid lightgray;' +
      '    border-collapse: collapse;' +
      '    padding: 2px 1px 1px;' +
      '}' +
      'th, td {' +
      '    padding-right: 10px;' +
      '    text-align: left;' +
      '    font-weight: normal;' +
      '}' +
      'th {' +
      '    background-color: lightgray;' +
      '}' +
      'h1, h2 {' +
      '    font-weight: bold;' +
      '}'  +
      'h1 {' +
      '    font-size: 14pt;' +
      '}'  +
      'h2 {' +
      '    font-size: 12pt;' +
      '}' +
      '</style>' +
      '</head><body>' +
      this.panel.nativeElement.innerHTML
       + '</body></html>';
    const wnd = window.open('about:blank', '', '_blank');
    wnd.document.write(html);
  }

  get lopaImgBase64() {
    if (this.project && this.project.lopa) {
      return this.sanitizer.bypassSecurityTrustUrl(this.project.lopa);
    }
    return null;
  }

  protected updateChecklist() {
    this.projectService.getChecklist(this.project)
      .subscribe((projectChecklist) => {
        console.log('Received checklist:', projectChecklist);
        this.items = projectChecklist.items;
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-checklist/components/project-checklist/project-checklist.component.ts